module.exports = __webpack_public_path__ + "static/media/case_management.5f505c90.png";